import './ProcessBand.scss';

import classNames from 'classnames';
import { Container } from 'react-bootstrap';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MarketingSectionIntro } from '@components/marketing/MarketingSectionIntro/MarketingSectionIntro';

export type ProcessBandStepState = 'done' | 'current' | 'upcoming';
export type ProcessBandVariant = 'fvt' | 'hcp';

export interface ProcessBandStep {
  label: string;
  title: string;
  description: string;
  state: ProcessBandStepState;
  icon?: IconDefinition;
  timing?: string;
}

export interface ProcessBandProps {
  className?: string;
  id: string;
  steps: ProcessBandStep[];
  variant: ProcessBandVariant;
  // MarketingSectionIntro props
  heading: string;
  introEyebrow?: string;
  introLead: string;
}

export const ProcessBand = (props: ProcessBandProps) => {
  const { className, introEyebrow, introLead, heading, id, steps, variant } = props;

  const headingId = `${id}-heading`;
  const isHcp = variant === 'hcp';

  const content = (
    <>
      <MarketingSectionIntro
        className='process-band__intro'
        eyebrow={introEyebrow}
        heading={heading}
        headingId={headingId}
        variant={variant}
      >
        <p>{introLead}</p>
      </MarketingSectionIntro>

      <div className='process-band__steps'>
        {steps.map(step => (
          <article
            key={step.label}
            className={classNames(
              'process-band__step',
              `process-band__step--${step.state}`,
              !isHcp && !step.icon && 'process-band__step--no-icon',
            )}
          >
            {!isHcp && step.icon && (
              <span className='process-band__step-icon' aria-hidden='true'>
                <FontAwesomeIcon icon={step.icon} />
              </span>
            )}

            <span className='process-band__step-label'>{step.label}</span>

            <h3 className='process-band__step-title'>{step.title}</h3>

            <p className='process-band__step-body'>{step.description}</p>

            {step.timing && <div className='process-band__step-timing'>{step.timing}</div>}
          </article>
        ))}
      </div>
    </>
  );

  return (
    <section
      id={id}
      className={classNames('process-band', `process-band--${variant}`, className)}
      aria-labelledby={headingId}
    >
      {isHcp ? <Container fluid='xxl'>{content}</Container> : content}
    </section>
  );
};
